// libs
import React from 'react';
import PropTypes from 'prop-types';

// Props and Context
const propTypes = {
  links: PropTypes.array.isRequired,
};
const defaultProps = {};
const contextTypes = {
  t: PropTypes.func,
};

function SuggestionsLinks({ links }, { t }) {
  return (
    <div>
      <strong>{t('pages.single.suggestionsLinks')}</strong>
      <ul className="suggestions-list suggestions-list--link">
        {links.map(({ link_title: title, link }) =>
          <li key={link}>
            <a href={link} rel="noopener noreferrer" target="_blank">
              {title}
            </a>
          </li>,
        )}
      </ul>
    </div>
  );
}

SuggestionsLinks.propTypes = propTypes;
SuggestionsLinks.defaultProps = defaultProps;
SuggestionsLinks.contextTypes = contextTypes;

export default SuggestionsLinks;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/SuggestionsLinks.js